import styled from 'styled-components'

import { Button } from 'components/Button'
import { SvgImage } from 'components/SvgImage'

import { Color } from 'root-constants'

export const StyledDownloadLong = {
  Wrapper: styled.div<{ $isScrollable: boolean; $isCompactLayout: boolean }>`
    max-width: 375px;

    ${({ $isCompactLayout }) =>
      $isCompactLayout
        ? `
      flex: 1;
      min-height: 0;
      gap: 24px;
      justify-content: flex-start;
    `
        : `
      height: 100%;
      max-height: calc(100dvh - 48px);
      max-height: calc(100vh - 48px);
      justify-content: space-between;
    `}

    ${({ $isScrollable, $isCompactLayout }) =>
      !$isCompactLayout &&
      ($isScrollable
        ? `
      overflow-y: auto;
      gap: 12px;
    `
        : `
      overflow: hidden;
      gap: 48px;
    `)}

    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 24px 24px 0;
    margin: 0 auto;
  `,
  Container: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
  Title: styled.h1<{ $withoutMargin?: boolean }>`
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    margin-bottom: ${({ $withoutMargin }) => ($withoutMargin ? '0' : '8px')};
  `,
  Subtitle: styled.p`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: ${Color.INK_DARKEST};
  `,
  Description: styled.p`
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    margin: 16px 0 24px;
  `,
  SvgImage: styled(SvgImage)`
    align-self: center;
    aspect-ratio: 1/1;
    object-fit: contain;

    margin-bottom: 24px;
  `,
  SaleImage: styled.img`
    width: 100%;
  `,
  Button: styled(Button)`
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    color: ${Color.GOLD_LIGHTER};

    width: 228px;
    height: 48px;
    border-radius: 48px;
    background-color: ${Color.INK_DARKEST};

    padding: 16px 32px;
    margin-top: 24px;
  `,
  PostDownloadSteps: styled.ul`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    list-style-type: decimal;

    margin-top: 16px;
    margin-left: 16px;

    li {
      display: list-item;
    }
  `,
  PostDownloadTitle: styled.p`
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    /* margin: 12px 0; */
  `,
  EmailLabel: styled.div`
    max-width: 304px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    background: ${Color.GOLD_LIGHTEST};
    border-radius: 8px;
    border: 2px solid ${Color.GOLD_DARKEST};

    & p {
      font-size: clamp(14px, 2.5vw, 16px);
      font-weight: 700;
      color: ${Color.GOLD_DARKEST};
      word-break: break-word;
    }

    padding: 8px 12px;
    margin: 4px 0 12px;
  `,
  Disclaimer: styled.div<{ $isCompactLayout?: boolean }>`
    display: inline-flex;
    padding: 12px;
    align-items: flex-start;
    gap: 10px;

    border-radius: 22px;
    background: ${Color.GOLD_LIGHTEST};
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);

    margin: ${({ $isCompactLayout }) =>
      $isCompactLayout ? '0 0 32px' : 'auto 0 32px'};
  `,
  DisclaimerText: styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: ${Color.GOLD_DARKEST};

    & strong {
      font-weight: 700;
      line-height: 24px;
    }

    & a {
      color: ${Color.GOLD_DARKEST};
      font-weight: 600;
      text-decoration: underline;
      cursor: pointer;
    }
  `,
  StyledSvgImage: styled(SvgImage)`
    min-width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1/1;
  `,
}
